/* Nakylo · offres de la zone d'achat (blocs nky_offre de main-product).
   Chaque offre est une carte ; les offres d'une même section forment un seul choix. Au clic sur « Ajouter
   au panier », si une offre est choisie, on ajoute une pièce par ligne (avec sa couleur et sa taille) au
   lieu de laisser Dawn ajouter une seule variante. La remise « x offert(s) » est faite par Shopify
   (remise automatique) : ce script ne touche jamais aux prix du panier. */
(function () {

  function formatPrix(cents, format) {
    var val = (cents / 100).toFixed(2), entier = val.split('.')[0], dec = val.split('.')[1];
    var milliers = function (n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); };
    return (format || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, cle) {
      switch (cle) {
        case 'amount_no_decimals': return milliers(entier, ',');
        case 'amount_with_comma_separator': return milliers(entier, '.') + ',' + dec;
        case 'amount_no_decimals_with_comma_separator': return milliers(entier, '.');
        case 'amount_with_apostrophe_separator': return milliers(entier, "'") + '.' + dec;
        default: return milliers(entier, ',') + '.' + dec;
      }
    });
  }

  function brancher(zone) {
    var offres = Array.prototype.slice.call(zone.querySelectorAll('[data-nky-offre]'));
    if (!offres.length || zone.dataset.nkyOffres) return;
    zone.dataset.nkyOffres = '1';
    var source = zone.querySelector('[data-nky-variantes]');
    var variantes = source ? JSON.parse(source.textContent) : [];
    var gravSrc = zone.querySelector('[data-nky-gravures]');
    var gravures = gravSrc ? JSON.parse(gravSrc.textContent) : null;
    /* le bloc prix de Dawn place avant lui un formulaire « paiement en plusieurs fois », sans bouton */
    var form = zone.querySelector('form[data-type="add-to-cart-form"]') || zone.querySelector('form[action*="/cart/add"]');

    /* cadeaux des lots (03/10) : règles « tel article offert dès N pièces de ce produit », retenues pour le panier
       (nky-panier.js les remet ou les retire quand le client change les quantités) */
    try {
      var regles = JSON.parse(localStorage.getItem('nky-cadeaux') || '{}'), vus = {}, liste = [];
      zone.querySelectorAll('[data-nky-cadeau]').forEach(function (c) {
        var cle = c.dataset.nkyCadeau + '@' + c.dataset.palier;   /* même article à deux paliers = deux cadeaux (09/10) */
        if (vus[cle]) return; vus[cle] = 1;
        liste.push({ v: +c.dataset.nkyCadeau, p: +c.dataset.palier });
      });
      var produit = offres[0].dataset.nkyProduit;
      if (produit && liste.length) { regles[produit] = liste; localStorage.setItem('nky-cadeaux', JSON.stringify(regles)); }
      else if (produit && regles[produit]) { delete regles[produit]; localStorage.setItem('nky-cadeaux', JSON.stringify(regles)); }
    } catch (e) { /* stockage indisponible : les cadeaux partent quand même avec le lot */ }

    function radio(o) { return o.querySelector('.nky-offre__radio'); }
    function active() { return offres.filter(function (o) { return radio(o).checked; })[0] || null; }

    function varianteDe(piece) {
      var choix = [];
      /* option commune au lot (ex. langue de gravure) : un seul menu au-dessus des pièces */
      var offre = piece.closest('[data-nky-offre]');
      var champs = Array.prototype.slice.call(piece.querySelectorAll('[data-option]'));
      if (offre) champs = champs.concat(Array.prototype.slice.call(offre.querySelectorAll('[data-nky-commun] [data-option]')));
      champs.forEach(function (el) {
        if (el.tagName === 'SELECT' || el.checked) choix[+el.dataset.option] = el.value;
      });
      return variantes.filter(function (v) {
        return v.options.every(function (val, i) { return choix[i] === undefined || choix[i] === val; });
      })[0];
    }

    function majPrix(o) {
      var pieces = o.querySelectorAll('[data-nky-piece]');
      if (!pieces.length) return;
      var payes = +o.dataset.payes, prix = [], refs = [];
      pieces.forEach(function (p) {
        var v = varianteDe(p); prix.push(v ? v.price : 0);
        refs.push(v && v.compare_at_price > v.price ? v.compare_at_price : (v ? v.price : 0));
        /* « menus + photo » : la photo de la pièce suit la variante choisie */
        var photo = p.querySelector('[data-nky-piece-photo]'), img = v && v.featured_image && v.featured_image.src;
        if (photo && img) photo.src = img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120';
      });
      prix.sort(function (a, b) { return b - a; });          /* les pièces offertes sont les moins chères */
      var fixe = o.dataset.prixFixe ? +o.dataset.prixFixe : 0;
      var barre = prix.reduce(function (a, b) { return a + b; }, 0);
      var pct = o.dataset.pct ? +o.dataset.pct : 0;   /* remise en % : comme Shopify, pièce par pièce, au centime inférieur */
      var rp = o.dataset.remisePiece ? +o.dataset.remisePiece : 0;   /* remise par pièce, dans la devise du visiteur */
      var total = fixe || (rp ? prix.reduce(function (a, p) { return a + p - rp; }, 0)
                       : pct ? prix.reduce(function (a, p) { return a + p - Math.floor(p * pct / 100 + 1e-6); }, 0)
                               : prix.slice(0, payes).reduce(function (a, b) { return a + b; }, 0));
      var f = o.dataset.format;
      /* prix barré : même calcul que la page (nky-achat-offre) — réglage « barre_mult » = prix de l'offre × facteur ;
         offre d'une seule pièce = prix de référence de la variante (compare_at). Avant le 09/10, un changement de couleur
         remettait le barré à la somme des prix et faisait mentir « Vous économisez … ». */
      var bm = o.dataset.barreMult ? +o.dataset.barreMult : 0;
      if (bm > 1) barre = Math.round(total * bm);
      else if (refs.length === 1) barre = refs[0];
      var elPrix = o.querySelector('[data-nky-prix]'), elBarre = o.querySelector('[data-nky-barre]');
      if (elPrix) elPrix.textContent = formatPrix(total, f);
      if (elBarre) elBarre.textContent = formatPrix(barre, f);
      var elPiece = o.querySelector('[data-nky-piece-prix]');
      if (elPiece && elPiece.dataset.modele && prix.length)
        /* lot vendu en variante (data-unites, 22/10) : une seule « pièce » au panier, mais le prix à l'unité divise par le nombre d'objets */
        elPiece.textContent = elPiece.dataset.modele.replace('§', formatPrix(Math.round(total / (+o.dataset.unites || prix.length)), f));
    }

    /* la 1re image de la galerie prend la photo de la variante choisie (gravure, couleur), y compris une photo
       masquée sur la page (bracelet gravé en anglais). Sans setActiveMedia de Dawn : il ferait remonter la page
       jusqu'à la galerie, en plein choix des pièces sur téléphone. */
    function montrerVariante(v) {
      var src = v && v.featured_image && v.featured_image.src;
      var galerie = document.querySelector('media-gallery');
      if (!src || !galerie || !galerie.elements || !galerie.elements.viewer) return;
      var premier = galerie.elements.viewer.querySelector('[data-media-id]');
      if (!premier) return;
      var id = premier.dataset.mediaId, brut = id.split('-').pop();
      var url = function (w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; };
      document.querySelectorAll('[data-media-id="' + id + '"] img, [data-target="' + id + '"] img, product-modal [data-media-id="' + brut + '"]').forEach(function (img) {
        if (img.tagName !== 'IMG') return;
        img.removeAttribute('srcset');
        img.src = url(img.closest('[data-target]') ? 240 : 1500);
      });
      galerie.elements.viewer.querySelectorAll('[data-media-id]').forEach(function (el) { el.classList.remove('is-active'); });
      premier.classList.add('is-active');
      if (premier.parentElement) premier.parentElement.scrollTo({ left: premier.offsetLeft, behavior: 'smooth' });
      var vignette = galerie.elements.thumbnails && galerie.elements.thumbnails.querySelector('[data-target="' + id + '"]');
      if (vignette && galerie.setActiveThumbnail) galerie.setActiveThumbnail(vignette);
    }

    function majSelection() {
      offres.forEach(function (o) {
        var on = radio(o).checked, p = o.querySelector('[data-nky-pieces]');
        o.classList.toggle('is-on', on);
        if (p) p.hidden = !on;
      });
    }

    offres.forEach(function (o) {
      radio(o).addEventListener('change', majSelection);
      o.addEventListener('change', function (e) {
        zone.dataset.nkyChoix = '1';
        if (e.target.dataset.option === undefined) return;
        majPrix(o);
        var piece = e.target.closest('[data-nky-piece]') || o.querySelector('[data-nky-piece]');
        if (piece) montrerVariante(varianteDe(piece));
      });
    });
    if (!active()) { radio(offres[0]).checked = true; }
    majSelection();

    if (!form) return;
    /* capture sur document : on passe avant le gestionnaire de Dawn, qui écoute le formulaire lui-même */
    document.addEventListener('submit', function (e) {
      if (e.target !== form) return;
      var o = active();
      if (!o) return;
      e.preventDefault(); e.stopImmediatePropagation();

      var parId = {}, varParId = {}, manque = false;
      var estKit = o.hasAttribute('data-nky-kit');
      if (estKit) {
        var kitSource = o.querySelector('[data-nky-kit-variantes]');
        var kitVariantes = kitSource ? JSON.parse(kitSource.textContent) : [];
        var vMain = variantes.filter(function (v) { return v.available; })[0];
        var vKit  = kitVariantes.filter(function (v) { return v.available; })[0];
        if (!vMain || !vKit) { manque = true; } else { parId[vMain.id] = 1; parId[vKit.id] = 1; varParId[vMain.id] = vMain; varParId[vKit.id] = vKit; }
      } else {
      var pieces = o.querySelectorAll('[data-nky-piece]');
      if (pieces.length) {
        pieces.forEach(function (p) {
          var v = varianteDe(p);
          if (!v || !v.available) { manque = true; return; }
          parId[v.id] = (parId[v.id] || 0) + 1;
          varParId[v.id] = v;
        });
      } else {
        var vid = o.dataset.variante || form.querySelector('[name="id"]').value;
        parId[vid] = (+o.dataset.payes) + (+o.dataset.offerts);
        varParId[vid] = variantes.filter(function (v) { return String(v.id) === vid; })[0];
      }
      }
      var erreur = zone.querySelector('.product-form__error-message-wrapper');
      var afficherErreur = function (msg) {
        if (!erreur) { alert(msg); return; }
        erreur.hidden = false;
        var m = erreur.querySelector('.product-form__error-message'); if (m) m.textContent = msg;
      };
      if (manque) { afficherErreur(o.dataset.msgIndispo); return; }
      if (erreur) erreur.hidden = true;

      var drawer = document.querySelector('cart-drawer');
      var corps = { items: Object.keys(parId).map(function (id) {
        var item = { id: +id, quantity: parId[id] };
        if (gravures && varParId[id]) {
          var texte = null;
          varParId[id].options.forEach(function (opt) { if (gravures[opt]) texte = gravures[opt]; });
          if (!texte) { var cles = Object.keys(gravures); if (cles.length) texte = gravures[cles[0]]; }
          if (texte) { var lbl = o.dataset.msgGravure || 'Gravure'; item.properties = {}; item.properties[lbl] = texte; }
        }
        return item;
      }) };
      /* cure vendue au sachet (data-lignes, 25/10 : « Cure 3 mois » = 1 ligne de 3 sachets) : la ligne emporte les paliers de la
         page (« _paliers » = N=variante, « _noms » = N=titre de l'offre) ; nky-panier.js fait suivre le prix et le libellé quand
         le client change la quantité dans le panier (2 sachets = prix de la cure 2 mois) */
      var nLignes = +o.dataset.lignes || 0;
      if (nLignes && o.dataset.variante) {
        var paliers = [], noms = [];
        zone.querySelectorAll('[data-nky-offre][data-lignes][data-variante]').forEach(function (x) {
          paliers.push(x.dataset.lignes + '=' + x.dataset.variante);
          var t = x.querySelector('.nky-offre__titre');
          if (t) noms.push(x.dataset.lignes + '=' + t.textContent.trim());
        });
        corps.items = [{ id: +o.dataset.variante, quantity: nLignes, properties: { _paliers: paliers.join(';'), _noms: noms.join('|') } }];
      }
      /* offre choisie SANS cadeau (« seule », réglage « cadeaux » décoché, 09/10) : nky-panier.js n'ajoute pas les cadeaux
         de ce produit tant qu'un lot avec cadeaux n'est pas ajouté ; un lot avec cadeaux lève ce choix */
      try {
        var cleSans = 'nky-sans-cadeau-' + o.dataset.nkyProduit;
        if (o.querySelector('[data-nky-cadeau]')) sessionStorage.removeItem(cleSans); else sessionStorage.setItem(cleSans, '1');
      } catch (e) { /* stockage indisponible : le panier remet les cadeaux du palier */ }
      /* les cadeaux du lot : une ligne à part (propriété « _cadeau »), rendue gratuite par la remise de lot Shopify */
      var dejaCadeau = {}, totalLot = (+o.dataset.payes || 0) + (+o.dataset.offerts || 0);
      o.querySelectorAll('[data-nky-cadeau]').forEach(function (c) {
        dejaCadeau[c.dataset.nkyCadeau] = 1;
        corps.items.push({ id: +c.dataset.nkyCadeau, quantity: 1, properties: { _cadeau: 'lot' } });
      });
      /* tuiles « cadeaux par palier » sous les offres (03/10) : celles que ce lot débloque partent aussi */
      zone.querySelectorAll('.nky-cadeaux [data-nky-cadeau]').forEach(function (c) {
        if (dejaCadeau[c.dataset.nkyCadeau] || +c.dataset.palier > totalLot) return;
        dejaCadeau[c.dataset.nkyCadeau] = 1;
        corps.items.push({ id: +c.dataset.nkyCadeau, quantity: 1, properties: { _cadeau: 'lot' } });
      });
      zone.querySelectorAll('[data-nky-addon]').forEach(function (a) {
        if (!a.querySelector('.nky-addon-ligne__check, .nky-addon-carte__check') || !a.querySelector('.nky-addon-ligne__check, .nky-addon-carte__check').checked) return;
        /* en tête de la requête (31/10, fontaine chat) : Shopify affiche en premier le dernier article d'un ajout groupé ;
           la case cochée (filtres, livre…) doit tomber SOUS le produit principal dans le panier */
        corps.items.unshift({ id: +a.dataset.nkyAddon, quantity: 1 });
      });
      if (drawer && drawer.getSectionsToRender) {
        corps.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
        corps.sections_url = window.location.pathname;
      }
      var bouton = form.querySelector('[type="submit"]');
      if (bouton) { bouton.setAttribute('aria-disabled', 'true'); bouton.classList.add('loading'); }
      fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(corps)
      }).then(function (r) { return r.json(); }).then(function (rep) {
        if (rep.status) { afficherErreur(rep.description || rep.message); return; }
        document.dispatchEvent(new CustomEvent('nky:ajoute'));
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(rep);
        } else {
          window.location = (window.routes && window.routes.cart_url) || '/cart';
        }
      }).catch(function () {
        afficherErreur(o.dataset.msgErreur);
      }).finally(function () {
        if (bouton) { bouton.removeAttribute('aria-disabled'); bouton.classList.remove('loading'); }
      });
    }, true);
  }

  /* une zone = la zone d'achat qui contient les offres ; la brancher deux fois ajouterait deux fois au panier */
  function tout() {
    var vues = [];
    document.querySelectorAll('[data-nky-offre]').forEach(function (o) {
      var zone = o.closest('product-info') || o.closest('.shopify-section');
      if (zone && vues.indexOf(zone) < 0) { vues.push(zone); brancher(zone); }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
  document.addEventListener('shopify:section:load', tout);   /* éditeur de thème */
})();
